import React from "react";
import '../../css/myCss.css';
import '../../css/color.css';
import '../../css/project.css';
import {Link} from "react-router-dom";

const PageTitle=(props)=>{
    const {currentPage}=props;

    const titleItems=['Home','Explorer','Search','Statistics','Download','Help','Contact'];
    const linkTarObj={
        'Home':'/home',
        'Explorer':'/explorer',
        'Search':'/search',
        'Statistics':'/statistics',
        'Download':'/download',
        'Help':'/help',
        'Contact':'/contact'
    }

    return <div
        className={'lh60 pos-re flex-r-w-sb-c wp100 bg-main2 pos-re font-white z-max shadow'}
    >
        <div
            className={'wa fs30 h60 lh60 ml40 mr60 bold italic '}
        >TSCRE</div>
        <div
            className={'flex-r-w-fs-c mr30'}
        >
            {titleItems.map((item,index)=>{
                return<Link
                    // target = "_blank"
                    to={{
                        pathname:linkTarObj[item],
                        // search:text
                    }}
                >
                    <div
                        // onClick={()=>{
                        //
                        // }}
                        className={'fs20 h60 mr50 lh60 center roboto bold '+(item===currentPage ?'navi-activate font-sub' : 'font-white')}
                    >
                        {item}
                    </div>
                </Link>
            })}
        </div>
    </div>
}

export default PageTitle;